export default {
  SET_COMMENTS: (state, payload) => {
    state.comments = payload;
    state.ffcomment = payload[0]?.ffcomments;
  },

  SET_SIGNATURE_COMMENTS: (state, payload) => {
    state.signaturecomments = payload;
  },
};
